export default {
  CLICK_ACTION_LINK_CLASS: 'ws-image-click-action',
};
